export const GovernmentAccountTab = ({
  sss,
  tin,
  philhealth,
  pagibig,
  setsss,
  setTin,
  setPhilhealth,
  setPagibig,

  isEditMode
}) => {
  return (
    <div className="accounts-tab column" style={{ marginTop: "20px" }}>
      <div className="accounts-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">SSS Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-SSSNumber" placeholder="SSS Number"
              readOnly={!isEditMode} value={sss} onChange={(e) => setsss(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Tin Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-TinNumber" placeholder="Tin Number"
              readOnly={!isEditMode} value={tin} onChange={(e) => setTin(e.target.value)}
            /></div>
        </div>
        {/* Passport moved to Tab 2 */}
      </div>
      <div className="accounts-tab-itemHolder info-item-holder row" style={{ justifyContent: "normal" }}>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Philhealth Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-PhilhealthNumber" placeholder="Philhealth Number"
              readOnly={!isEditMode} value={philhealth} onChange={(e) => setPhilhealth(e.target.value)}
            /></div>
        </div>
        <div className="info-item info-item3 column">
          <div className="info-item-label">Pagibig Number</div>
          <div className="info-item-input">
            <input id="AddEmployee-PagibigNumber" placeholder="Pagibig Number"
              readOnly={!isEditMode} value={pagibig} onChange={(e) => setPagibig(e.target.value)}
            /></div>
        </div>
      </div>
    </div>
  )
}